<template>
    <div>
        <div class="swiper-container-column">
            <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="column in columns">
                    <a :href="route(route_list, 'site.plus.column.contents', {category_id:column.plus_category_id,id:column.id} )">
                        <div class="c-slider-news__img column-img" v-if="isEmpty(column.media_thumbnail_url)">
                            <img src="/src/assets/img/common/dummy-thumbnail-landscape.jpg" alt="" loading="lazy">
                        </div>
                        <div class="c-slider-news__img column-img" v-else>
                            <webp-picture :webp="column.webp_thumbnail_url" class="inherit">
                                <img :src="column.image_thumbnail_url" alt="" loading="lazy">
                            </webp-picture>
                        </div>
                        <div class="c-slider-news__text column-text">
                            <div class="c-slider-news__text-inner">
                                <p class="c-lead-bold">{{ $filters.truncate(column.title, 33, "...") }}</p>
                                <div v-if="column.is_new" class="c-slider-normal__icon">
                                    <div class="c-label is-new">New</div>
                                    <div class="c-label is-weekly">{{ column.categories_title }}</div>
                                </div>
                                <div v-else class="c-slider-normal__icon">
                                    <div class="c-label is-weekly">{{ column.categories_title }}</div>
                                </div>
                                <div class="c-slider-news__text-label">
                                    <p class="c-date">
                                        {{ date_format(column.dsp_start_date) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow">
        </div>
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
import Swiper from 'swiper/bundle';
import moment from 'moment';
export default {
    props: [
        'columns',
        'route_list',
    ],
    mixins: [routeMixin],
    mounted: function() {
        // 3項目のため、専用のswiperを用意する
        const swiper = new Swiper('.swiper-container-column', {
            freeMode: {
                enabled: true,
                momentumBounce: true,
            },
            slidesPerView: 2.5,
            navigation: {
                nextEl: ".next-arrow",
                prevEl: ".prev-arrow",
            },
            breakpoints: {
                767: {
                    slidesPerView: 3,
                },
            }
        });
    },
    methods:{
        isEmpty(value){
            if(value == ''){
                return true;
            }
            return false;
        },
        date_format(value) {
            return moment(value).format('YYYY年M月D日');
        }
    }
}
</script>

<style scoped>
.swiper-container-column {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.label-box{
  display: flex;
}
.c-label-limited{
    max-width: 180px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow-x: hidden;
    background: #ff873c;
    color: #fff;
}

.c-slider-normal__icon {
    width: 210px;
    @media screen and (max-width: 767px) {
        width: 100%;
    }
}

</style>
